import { useEffect, useRef } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import Header from "./Header";
import PageTop from "./PageTop";
import Home from "../pages/Home";
import About from "../pages/About";
import Portfolio from "../pages/Portfolio";
import Contact from "../pages/Contact";
import Skills from "../pages/Skills";
import Skill from "../pages/Skill";
import Service from "../pages/Service";
import Testimonials from "../pages/Testimonials";

function MainPage() {
  // 🧩 Create a ref to attach custom scroll container
  const scrollRef = useRef(null);

  useEffect(() => {
    // 🧩 Set the default scroller for GSAP's ScrollTrigger to the custom scroll container
    ScrollTrigger.defaults({
      scroller: scrollRef.current,
    });

    // 🧩 Refresh all ScrollTriggers (in case layout changes)
    ScrollTrigger.refresh();
  }, []);

  return (
    // 🧩 Main scrollable wrapper with snapping and smooth scrolling enabled
    <div
      ref={scrollRef}
      className="h-screen overflow-y-scroll snap-y snap-mandatory scroll-smooth"
    >
      {/* 🧩 Sticky header at the top */}
      <Header />

      {/* 🧩 Page sections - vertically stacked */}
      <Home />
      <About />
      <Skills />
      <Skill />
      <Portfolio />
      <Service />
      <Testimonials />
      <Contact />
      {/* 🧩 Scroll-to-top button, tied to scrollRef */}
      <PageTop scrollContainerRef={scrollRef} />
    </div>
  );
}

export default MainPage;
